import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { SalesTeamOption } from '@user/components/Dashboard/widgets/hooks'

type Props = {
  leaveOwners?: boolean
}

export function useHandlers(props: Props) {
  const { leaveOwners } = props

  const {
    values: { salesTeamIds: salesTeamIdsValue },
    setFieldValue,
  } = useFormikContext<{
    salesTeamIds: number[]
    assigneeIds: string[]
    numDays?: number
  }>()

  const getId = useCallback((option: SalesTeamOption) => {
    return String(option.id)
  }, [])

  const renderSummary = useCallback((options, text: string) => {
    if (options.length === 1) {
      return options[0].label || options[0].name
    } else {
      return `${options.length} ${text}`
    }
  }, [])

  const handleSelectSalesTeam = useCallback(
    (salesTeamIds) => {
      const salesTeamsIds = salesTeamIds.map((team) => team.id)

      setFieldValue('salesTeamIds', salesTeamsIds)
      if (
        !salesTeamsIds ||
        salesTeamsIds.length == 0 ||
        (salesTeamIdsValue.length > salesTeamsIds.length && !leaveOwners)
      ) {
        setFieldValue('assigneeIds', [])
      }
    },
    [setFieldValue, salesTeamIdsValue.length, leaveOwners],
  )

  const matchFilter = useCallback((option, _getLabel, searchValue) => {
    const searchIn = [option.name]
    return searchIn.some((entry) =>
      entry.toLowerCase().includes(searchValue.toLowerCase()),
    )
  }, [])

  const isOptionEqual = useCallback(
    (optionA: SalesTeamOption, optionB: SalesTeamOption) =>
      optionA.id === optionB.id,
    [],
  )

  return {
    renderSummary,
    handleSelectSalesTeam,
    matchFilter,
    isOptionEqual,
    getId,
  }
}
